import BaseService from "@/boot/BaseService";
class SectorEconomicoService extends BaseService {
    constructor() {
        super(null, "/sector-economico");
    }
    async index() {
        return await this.get("/");
    }

}

export default new SectorEconomicoService();
